import React from 'react';
import { AnimationGlobalStyle } from './animation';
import { HTMLGlobalStyle } from './html';

export const GlobalStyle = () => (
  <>
    <AnimationGlobalStyle />
    <HTMLGlobalStyle />
  </>
);
